import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

// Agents opens as the Fleet; only the per-policy drill-down still needs the list, since Fleet cannot filter by policy.
const GuardianAgentsRoute: React.FC<{ list: React.ReactNode }> = ({ list }) => {
  const [searchParams] = useSearchParams();
  return searchParams.has('policy') ? (
    <>{list}</>
  ) : (
    <Navigate to="/dashboard/guardian-fleet" replace />
  );
};

export default GuardianAgentsRoute;
